<template>
  <vs-popup title="Selecionar usuários para manter ativos" :active.sync="isActiveLocal"  @close="isActiveLocal = false">
    <div v-if="loading" class="text-center">Carregando usuários...</div>
    <div v-else>
      <div class="warning-box">
        Caso o cliente <b>{{tenantName}}</b> estiver com <b>Distribuição Automática (sem Caixa de Entrada)</b>, os atendimentos abertos dos usuários removidos serão transferidos para o administrador ID 1 ({{ adminTargetName }}).
      </div>

      <p class="mt-3 mb-3">
        Selecione {{ limit }} usuários para permanecerem ativos após a redução do limite.
      </p>

      <div class="user-selection-list">
        <div v-for="user in users" :key="user.id" class="user-selection-item">
          <vs-checkbox
            :disabled="isSelectionDisabled(user.id)"
            :vs-value="user.id"
            v-model="localSelected"
          >
            <div class="user-selection-content">
              <img
                v-if="user.image"
                :src="user.image"
                class="user-avatar"
                alt="user-image"
              />

              <div class="user-selection-text">
                <div class="user-name">
                  {{ user.name }}
                  <span class="user-username" v-if="user.username">({{ user.username }})</span>
                </div>
                <div class="user-email">{{ user.email }}</div>
                <div class="user-department" v-if="user.userDepartment && user.userDepartment.name">
                  Departamento: {{ user.userDepartment.name }}
                </div>
              </div>
            </div>
          </vs-checkbox>
        </div>
      </div>
      <div class="d-flex justify-end gap-2 mt-3">
        <vs-button type="border" @click="handleCancel">Cancelar</vs-button>
        <vs-button :disabled="isConfirmDisabled" @click="confirmSelection">Confirmar</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'UserSelectionModal',
  props: {
    tenantName: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    users: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: () => []
    },
    adminUser: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      localSelected: []
    };
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.active;
      },
      set(newVal) {
        this.$emit('update:active', newVal);
      }
    },
    isConfirmDisabled() {
      return this.localSelected.length !== this.limit;
    },
    adminTargetName() {
      if (this.adminUser && (this.adminUser.name || this.adminUser.username)) { return this.adminUser.name || this.adminUser.username; }
      return 'administrador';
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler(newVal) {
        this.localSelected = Array.isArray(newVal) ? [...newVal] : [];
      }
    },
    active(newVal) {
      if (!newVal) {
        this.localSelected = [];
      }
    }
  },
  methods: {
    isSelectionDisabled(userId) {
      return this.localSelected.length >= this.limit && !this.localSelected.includes(userId);
    },
    confirmSelection() {
      if (this.isConfirmDisabled) {
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: `Selecione exatamente ${this.limit} usuários para manter ativos.`
        });
        return;
      }
      this.$emit('update:selected', this.localSelected);
      this.$emit('confirm', this.localSelected);
    },
    handleCancel() {
      this.$emit('update:active', false);
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.user-selection-list {
  max-height: 400px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.user-selection-item {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 0.5rem;
}

.user-selection-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.user-selection-text .user-name {
  font-weight: 600;
  color: #333;
}

.user-selection-text .user-email,
.user-username,
.user-selection-text .user-department {
  font-size: 12px;
  color: #666;
}

.warning-box {
  border: 1px solid #f5c36a;
  background: #fff7e6;
  color: #8a5a00;
  border-radius: 6px;
  padding: 0.75rem;
  font-size: 12px;
  margin-bottom: 0.75rem;
  line-height: 1.4;
  font-weight: 600;
}
</style>
